import React, { useMemo } from 'react';
import ThemeConstants from '../../../../config/theme/theme_constants';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { UserInterface } from '../../../../core/components/user/domain/interfaces/user_interface';
import { UserThemeInterface } from '../../../course/domain/interface/user_theme_interface';
import UserTitle from '../../../course/presentation/components/user_title';
import AreaOfDevelopment from '../../../course/presentation/components/area_of_development';
import ArrowBackIcon from '../../../../assets/images/arrow_back_black_icon.svg?react';
import { useTranslation } from '../../../../i18n/useTranslation';

const UserCertificatesPage: React.FC = () => {
  const { t } = useTranslation();
  const theme = ThemeConstants();
  const { course_theme } = useOutletContext<UserInterface>();
  const navigate = useNavigate();
  const finishedThemes = useMemo(() => course_theme.filter(theme => theme.status === 'completed' && theme._themeId), [course_theme]);

  return (
    <div className="min-h-dvh max-lg:pt-16 lg:pt-[5.6dvh] max-lg:px-[3%] lg:px-[1%] flex flex-col gap-8 items-center relative max-md:pb-32 md:pb-29">
      <button
        className="absolute top-8 left-5 cursor-pointer w-6 h-6 flex items-center justify-center"
        onClick={() => navigate(-1)}
      >
        <ArrowBackIcon color="black" className="w-4.25 h-auto" />
      </button>
      <UserTitle subtitle={t('profile.certificates_page.subtitle')} description={t('profile.certificates_page.description')}/>
      <div className="flex flex-col flex-1 gap-4 w-full max-w-115 mx-auto">
        <p className="text-base font-bold text-black" style={{ color: theme.UvibesGray }}>{t('profile.certificates_page.finished_axes')}</p>
        <div className='flex flex-col gap-5 items-center'>
          {finishedThemes?.map((axis: UserThemeInterface, index: number) => (
            typeof axis._themeId === 'object' && <AreaOfDevelopment
              key={`area_of_development_${index}`}
              id={axis._themeId!._id}
              name={axis._themeId!.name}
              img={axis._themeId!.picture}
              backgroundColor={axis._themeId!.color}
              extraUrl={'/certificate'}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserCertificatesPage;
